import { getAdminOrCareAdvisorPrefix } from '@brands/Utils/staffScopedApiPrefix';
import { client } from '../client';
import { UserProfile } from './types/UserProfile';

export const activateUserById = async (userId: number, userRole?: string): Promise<UserProfile> => {
  const { data } = await client.post<UserProfile>(`${getAdminOrCareAdvisorPrefix(userRole)}/users/${userId}/reactivate`);

  return data;
};
